import React from "react";
import { Link } from "react-router-dom";
import './CTAStyle.css';

const CTASection = () => {
  return (
    <section className="cta-section" style={{ cursor: "url('/images/shell.png'), auto" }}>
      <div className="cta-overlay">
        <div className="cta-content">
          <h2>با صنایع‌دستی ایرانی، به زندگی، روح ببخش.</h2>
          <p>آثار هنرمندان ایرانی، با اصالت و عشق</p>
          <Link to="/products" className="cta-button">
            مشاهده محصولات
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
